/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountCategoryEnum } from './accountCategoryEnum';
import { AccountProviderTypeEnum } from './accountProviderTypeEnum';


export interface AccountRequestSpec { 
    /**
     * Name for an account.
     */
    account_name?: string;
    provider: AccountProviderTypeEnum;
    category: AccountCategoryEnum;
    /**
     * Batch Id to which this account belongs.
     */
    batch_id: string;
    /**
     * Owner account Id.
     */
    master_account_id: string;
    /**
     * Used for partitioning accounts.
     */
    org_unit?: string;
    /**
     * Team to which account belongs.
     */
    team?: string;
    /**
     * Any comment related to account.
     */
    note?: string;
}
export namespace AccountRequestSpec {
}


